import * as R from 'ramda'
import {OrderAction} from './OrderActions'
import {OrderTab} from './OrderState'
import {InquiryWithDetails} from '../../../Entities/InquiryWithDetails'
import {InquiryPositionWithDetails} from '../../../Entities/InquiryPositionWithDetails'
import {update} from '../../../Data/ObjectHelper'
import {
    Inquiry,
    inquiryDecoder as inquiryDecoder
} from '../../../Entities/Inquiry'
import * as InquiryResource from '../../../Request/InquiryResource'
import {InquiryOrderRequestIdentifier, OrderFeedback} from './OrderFeedback'
import {Result} from '../../../Data/Result'
import {decodeHttpResponse, HttpError} from '../../../Data/Http'
import {Session} from '../../../Data/Session'
import {FeedbackLoop} from '../../../Data/FeedbackLoop'

export function initOrder(inquiryWithDetails: InquiryWithDetails): OrderTab {
    return {
        editable: {type: 'Locked'},
        invoiceAddressInput: copyInvoiceAddress(inquiryWithDetails.inquiry),
        deliveryAddressInput: copyDeliveryAddress(inquiryWithDetails.inquiry),
        inquiry: inquiryWithDetails.inquiry,
        positions: R.map(
            ({inquiryPosition}: InquiryPositionWithDetails) =>
                inquiryPosition,
            inquiryWithDetails.inquiryPositionsWithAttachments),
    }
}

type OrderLoop =
    FeedbackLoop<OrderTab, OrderFeedback>

export function orderReducer(
    session: Session,
    inquiryNumber: number,
    action: OrderAction,
    state: OrderTab
): OrderLoop {
    switch (action.type) {
        case 'NoAction':
            return {
                state: state,
                feedback: [],
            }
        case 'EditOrderTab':
            return {
                state: update({
                        editable: {
                            type: 'Pending',
                            value: null
                        }
                    },
                    state),
                feedback: [],
            }
        case 'SaveOrderTab':
            return {
                state: state,
                feedback: [
                    {
                        type: 'SendRequest',
                        identifier: {type: 'InquiryOrderTabSave'},
                        httpRequest:
                            InquiryResource.updateOrderDraft(
                                session.manufacturer.id,
                                inquiryNumber,
                                state.invoiceAddressInput,
                                state.deliveryAddressInput
                            ),
                    }
                ],
            }
        case 'DiscardOrderTab':
            return {
                state: update({
                        editable: {
                            type: 'Locked'
                        },
                        invoiceAddressInput: copyInvoiceAddress(state.inquiry),
                        deliveryAddressInput: copyDeliveryAddress(state.inquiry),
                    },
                    state),
                feedback: [],
            }
        case 'InvoiceAddressChanged':
            return {
                state: update({
                        invoiceAddressInput: update(
                            {[action.field]: action.value},
                            state.invoiceAddressInput
                        )
                    },
                    state),
                feedback: [],
            }
        case 'DeliveryAddressChanged':
            return {
                state: update({
                        deliveryAddressInput: update(
                            {[action.field]: action.value},
                            state.deliveryAddressInput
                        )
                    },
                    state),
                feedback: [],
            }
        case 'InquiryOrderTabSaveResponse':
            const result = decodeHttpResponse(inquiryDecoder(), action.result)
            return (() => {
                switch (result.type) {
                    case 'Ok':
                        return {
                            state: update({
                                    editable: {
                                        type: 'Locked'
                                    },
                                    deliveryAddressInput: update(
                                        copyDeliveryAddress(result.value),
                                        state.deliveryAddressInput
                                    ),
                                    invoiceAddressInput: update(
                                        copyInvoiceAddress(result.value),
                                        state.invoiceAddressInput
                                    )
                                },
                                state),
                            effects: [],
                            feedback: [],
                        }
                    case 'Err':
                        return {
                            state: update({
                                editable: {
                                    type: 'Failure',
                                    value: null,
                                    error: result.error
                                }
                            }, state),
                            effects: [],
                            feedback: [],
                        }
                }
            })()
    }
}

export function orderResponseAction(
    identifier: InquiryOrderRequestIdentifier,
    result: Result<HttpError, string>
): OrderAction {
    switch (identifier.type) {
        case 'InquiryOrderTabSave':
            return {
                type: 'InquiryOrderTabSaveResponse',
                result,
            }
    }
}

function copyDeliveryAddress(original: Inquiry) {
    return {
        deliveryName1: original.deliveryName1,
        deliveryName2: original.deliveryName2,
        deliveryName3: original.deliveryName3,
        deliveryName4: original.deliveryName4,
        deliveryFloor: original.deliveryFloor,
        deliveryRoom: original.deliveryRoom,
        deliveryStreet: original.deliveryStreet,
        deliveryHouseNumber: original.deliveryHouseNumber,
        deliveryZipCode: original.deliveryZipCode,
        deliveryCity: original.deliveryCity,
        deliveryCountry: original.deliveryCountry
    }
}

function copyInvoiceAddress(original: Inquiry) {
    return {
        invoiceName1: original.invoiceName1,
        invoiceName2: original.invoiceName2,
        invoiceName3: original.invoiceName3,
        invoiceName4: original.invoiceName4,
        invoiceStreet: original.invoiceStreet,
        invoiceHouseNumber: original.invoiceHouseNumber,
        invoiceZipCode: original.invoiceZipCode,
        invoiceCity: original.invoiceCity,
        invoiceCountry: original.invoiceCountry
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/Order/OrderReducer.ts